import React, { useEffect, useRef, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { ProductPreview } from './components/ProductPreview';
import { PainPoints } from './components/PainPoints';
import { ForWho } from './components/ForWho';
import { StatsBar } from './components/StatsBar';
import { TomosAccordion } from './components/TomosAccordion';
import { BonosGrid } from './components/BonosGrid';
import { Comparison } from './components/Comparison';
import { PricingCards } from './components/PricingCards';
import { UpgradeElite } from './components/UpgradeElite';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import ReactPixel from 'react-facebook-pixel';
// Intersection Observer wrapper for scroll animations
function FadeInSection({
  children
}: {
  children: React.ReactNode;
}) {
  const domRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100', 'translate-y-0');
          entry.target.classList.remove('opacity-0', 'translate-y-8');
          // Optional: unobserve after showing once
          // observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    if (domRef.current) {
      observer.observe(domRef.current);
    }
    return () => {
      if (domRef.current) observer.unobserve(domRef.current);
    };
  }, []);
  return <div ref={domRef} className="opacity-0 translate-y-8 transition-all duration-700 ease-out will-change-[opacity,transform]" data-id="element-0">
      {children}
    </div>;
}
export function App() {
  useEffect(() => {
    // Safe Meta Pixel Initialization to avoid 'parentNode' undefined error
    // by appending directly to document.head instead of searching for script tags
    ;
    (function (f: any, b: any, e: any, v: any) {
      if (f.fbq) return;
      const n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e);
      t.async = !0;
      t.src = v;
      b.head.appendChild(t);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '937331855399019');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-bg font-sans selection:bg-brand-mid selection:text-white" data-id="element-1">
      <UrgencyBar data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />

        <FadeInSection data-id="element-5">
          <Testimonials data-id="element-6" />
        </FadeInSection>

        <FadeInSection data-id="element-7">
          <ProductPreview data-id="element-8" />
        </FadeInSection>

        <FadeInSection data-id="element-9">
          <PainPoints data-id="element-10" />
        </FadeInSection>

        <FadeInSection data-id="element-11">
          <ForWho data-id="element-12" />
        </FadeInSection>

        <FadeInSection data-id="element-13">
          <StatsBar data-id="element-14" />
        </FadeInSection>

        <FadeInSection data-id="element-15">
          <TomosAccordion data-id="element-16" />
        </FadeInSection>

        <FadeInSection data-id="element-17">
          <BonosGrid data-id="element-18" />
        </FadeInSection>

        <FadeInSection data-id="element-19">
          <Comparison data-id="element-20" />
        </FadeInSection>

        <FadeInSection data-id="element-21">
          <PricingCards id="pricing" data-id="element-22" />
        </FadeInSection>

        <FadeInSection data-id="element-23">
          <UpgradeElite data-id="element-24" />
        </FadeInSection>

        <FadeInSection data-id="element-25">
          <Guarantee data-id="element-26" />
        </FadeInSection>

        <FadeInSection data-id="element-27">
          <FAQ data-id="element-28" />
        </FadeInSection>

        {/* Final Urgency & Pricing Block */}
        <FadeInSection data-id="element-29">
          <section className="pt-8 md:pt-12 pb-2 bg-white border-t border-gray-100" data-id="element-30">
            <div className="max-w-3xl mx-auto px-4 text-center mb-4 md:mb-6" data-id="element-31">
              <h2 className="text-[11px] md:text-sm font-bold text-red-600 tracking-wider uppercase mb-1.5" data-id="element-32">
                🔥 Última oportunidad
              </h2>
              <h3 className="font-heading text-[22px] md:text-3xl text-brand-dark mb-2 md:mb-4" data-id="element-33">
                No dejes que se acaben los cupos
              </h3>
              <div className="max-w-sm mx-auto mb-3 md:mb-4" data-id="element-34">
                <div className="flex justify-between text-[10px] md:text-xs font-bold text-brand-dark mb-1" data-id="element-35">
                  <span data-id="element-36">Cupos restantes</span>
                  <span className="text-red-600" data-id="element-37">68% TOMADOS</span>
                </div>
                <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-38">
                  <div className="h-full bg-gradient-to-r from-brand-cta to-red-500 rounded-full" style={{
                  width: '68%'
                }} data-id="element-39"></div>
                </div>
              </div>
              <p className="text-gray-500 text-[11px] md:text-sm font-medium" data-id="element-40">
                Cuando se acaben los cupos el precio sube y NO vuelve a bajar.
              </p>
            </div>
            <PricingCards id="pricing-final" data-id="element-41" />
          </section>
        </FadeInSection>
      </main>

      <Footer data-id="element-42" />
    </div>;
}